import { ENDPOINTS, sendAsyncRequest } from '../utils';
import { logger } from '../utils/logger';
import { PatrimonyParams, ApiResponse, PaginatedResponse } from '../types/api.types';
import { Patrimony } from '../store/patrimonies/types';

// GET ALL PATRIMONIES
const getPatrimonies = async (): Promise<PaginatedResponse<Patrimony>> => {
  const response = await sendAsyncRequest<PaginatedResponse<Patrimony>>('get', ENDPOINTS.PATRIMONIES, true, { filter: { order: ['RefPat'] },pat_levels:["1","2","3"], }, undefined);
  return response.data;
};

const getPatrimoniesWithPrestation = async (sdt_ids: string[]): Promise<PaginatedResponse<Patrimony>> => {
  const response = await sendAsyncRequest<PaginatedResponse<Patrimony>>('get', ENDPOINTS.PATRIMONIES, true, {  sdt_ids }, { filter: { order: ['RefPat'] },pat_levels:["1","2","3"] }, undefined);
  return response.data;
};

// GET PATRIMONIES BY AGENCY
const getPatrimonyListByAgency = async (id: string): Promise<PaginatedResponse<Patrimony>> => {
  const response = await sendAsyncRequest<PaginatedResponse<Patrimony>>(
    'get',
    ENDPOINTS.AGENCIES + '/' + id + ENDPOINTS.PATRIMONIES,
    true,
    { filter: { order: ['RefPat'] },pat_levels:["1","2","3"] },
    undefined,
  );
  return response.data;
};

// GET first patrimonies page,
const getSomePatrimonies = async (params: PatrimonyParams): Promise<PaginatedResponse<Patrimony>> => {
  const response = await sendAsyncRequest<PaginatedResponse<Patrimony>>(
    'get',
    ENDPOINTS.PATRIMONIES,
    true,
    params,
    undefined,
  );
  return response.data;
};

// GET PATRIMONIES BY AGENCY
const getPatrimonyDetail = async (id: string): Promise<Patrimony> => {
  const response = await sendAsyncRequest<Patrimony>('get', ENDPOINTS.PATRIMONIES + '/' + id, true, undefined, undefined);
  return response.data;
};

// GET PATRIMONY's services types
const getPatrimonyServiceTypes = async (id: string): Promise<ApiResponse> => {
  const response = await sendAsyncRequest<ApiResponse>('get', ENDPOINTS.PATRIMONIES + '/' + id + ENDPOINTS.SERVICES, true, undefined, undefined);
  return response.data;
};

// UPDATE PATRIMONY
const updatePatrimony = async (id: string, refPat: string, agencyId: string, serviceDeliveryTypeIds: string[]): Promise<ApiResponse> => {
  const response = await sendAsyncRequest<ApiResponse>('put', ENDPOINTS.PATRIMONIES + '/' + id, true, undefined, {  serviceDeliveryTypeIds });
  return response.data;
};

export const patrimonies = {
  getPatrimonies,
  getPatrimoniesWithPrestation,
  getPatrimonyListByAgency,
  getPatrimonyDetail,
  updatePatrimony,
  getSomePatrimonies,
  getPatrimonyServiceTypes
};
